/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import {HttpClient, HttpContext, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createFacility } from '../fn/facility/create-facility';
import { CreateFacility$Params } from '../fn/facility/create-facility';
import { deleteFacility } from '../fn/facility/delete-facility';
import { DeleteFacility$Params } from '../fn/facility/delete-facility';
import { FacilityHarvestDto } from '../models/facility-harvest-dto';
import { FacilityReportsDto } from '../models/facility-reports-dto';
import { FacilityResponse } from '../models/facility-response';
import { gatHarvestBasicResponse } from '../fn/facility/gat-harvest-basic-response';
import { GatHarvestBasicResponse$Params } from '../fn/facility/gat-harvest-basic-response';
import { getFacilityHarvests } from '../fn/facility/get-facility-harvests';
import { GetFacilityHarvests$Params } from '../fn/facility/get-facility-harvests';
import { getFacilityReports } from '../fn/facility/get-facility-reports';
import { GetFacilityReports$Params } from '../fn/facility/get-facility-reports';
import { HarvestBasicResponse } from '../models/harvest-basic-response';
import { updateFacility } from '../fn/facility/update-facility';
import { UpdateFacility$Params } from '../fn/facility/update-facility';

@Injectable({ providedIn: 'root' })
export class FacilityService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createFacility()` */
  static readonly CreateFacilityPath = '/api/facility';

  /**
   * Create Facility.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFacility()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFacility$Response(params: CreateFacility$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityResponse>> {
    return createFacility(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Facility.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createFacility$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFacility(params: CreateFacility$Params, context?: HttpContext): Observable<FacilityResponse> {
    return this.createFacility$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityResponse>): FacilityResponse => r.body)
    );
  }

  /** Path part for operation `updateFacility()` */
  static readonly UpdateFacilityPath = '/api/facility/{facilityId}';

  /**
   * Update Facility.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFacility()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFacility$Response(params: UpdateFacility$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityResponse>> {
    return updateFacility(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Facility.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFacility$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFacility(params: UpdateFacility$Params, context?: HttpContext): Observable<FacilityResponse> {
    return this.updateFacility$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityResponse>): FacilityResponse => r.body)
    );
  }

  /** Path part for operation `deleteFacility()` */
  static readonly DeleteFacilityPath = '/api/facility/{facilityId}';

  /**
   * Delete Facility.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFacility()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFacility$Response(params: DeleteFacility$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityResponse>> {
    return deleteFacility(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Facility.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFacility$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFacility(params: DeleteFacility$Params, context?: HttpContext): Observable<FacilityResponse> {
    return this.deleteFacility$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityResponse>): FacilityResponse => r.body)
    );
  }

  /** Path part for operation `getFacilityReports()` */
  static readonly GetFacilityReportsPath = '/api/facility/{facilityId}/facilityreport';

  /**
   * Get Facility Reports.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFacilityReports()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityReports$Response(params: GetFacilityReports$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityReportsDto>> {
    return getFacilityReports(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Facility Reports.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFacilityReports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityReports(params: GetFacilityReports$Params, context?: HttpContext): Observable<FacilityReportsDto> {
    return this.getFacilityReports$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityReportsDto>): FacilityReportsDto => r.body)
    );
  }

  /** Path part for operation `getFacilityHarvests()` */
  static readonly GetFacilityHarvestsPath = '/api/facility/{facilityId}/harvest';

  /**
   * Get Facility Harvests.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFacilityHarvests()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityHarvests$Response(params: GetFacilityHarvests$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FacilityHarvestDto>>> {
    return getFacilityHarvests(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Facility Harvests.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFacilityHarvests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityHarvests(params: GetFacilityHarvests$Params, context?: HttpContext): Observable<Array<FacilityHarvestDto>> {
    return this.getFacilityHarvests$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FacilityHarvestDto>>): Array<FacilityHarvestDto> => r.body)
    );
  }

  /** Path part for operation `gatHarvestBasicResponse()` */
  static readonly GatHarvestBasicResponsePath = '/api/facility/{facilityId}/harvest-basic-response';

  /**
   * Gat Harvest Basic Response.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gatHarvestBasicResponse()` instead.
   *
   * This method doesn't expect any request body.
   */
  gatHarvestBasicResponse$Response(params: GatHarvestBasicResponse$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestBasicResponse>>> {
    return gatHarvestBasicResponse(this.http, this.rootUrl, params, context);
  }

  /**
   * Gat Harvest Basic Response.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `gatHarvestBasicResponse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gatHarvestBasicResponse(params: GatHarvestBasicResponse$Params, context?: HttpContext): Observable<Array<HarvestBasicResponse>> {
    return this.gatHarvestBasicResponse$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HarvestBasicResponse>>): Array<HarvestBasicResponse> => r.body)
    );
  }

  copyFacility(facilityId: number, destinationFacilityGroupId: number): Observable<FacilityResponse> {
    return this.http.post(this.rootUrl + '/api/facility/copy', {}, { params: new HttpParams().set('facilityId', facilityId).set('destinationFacilityGroupId', destinationFacilityGroupId) });
  }

}
